var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/arrow-down-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-down-dark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-down"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4696501,15.921117 L5.39642239,9.84788931 C5.1035459,9.55498229 5.1035459,9.08012991 5.39642239,8.78725341 L6.10476421,8.07891159 C6.39718295,7.78649286 6.87108929,7.78594354 7.16417941,8.07766038 L11.9999833,12.8907898 L16.8357567,8.07766038 C17.1288468,7.78594354 17.6027532,7.78649286 17.8951719,8.07891159 L18.6035137,8.78725341 C18.8963902,9.08016043 18.8963902,9.55501281 18.6035137,9.84788931 L12.5303165,15.921117 C12.2374095,16.2139935 11.7625571,16.2139935 11.4696501,15.921117 Z",
    id: "arrow-down-dark",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDark);
export default __webpack_public_path__ + "static/media/arrow-down-dark.86c29487.svg";
export { ForwardRef as ReactComponent };